module.exports = __webpack_public_path__ + "static/media/bannerEsquentaBlackoutMobile.3488e8ff.jpg";